import React from 'react';
import heroImage from '../assets/heroImage.png';
import bgImage from '../assets/heroBg.png';

const Hero = () => {
  return (
    <div
      className="w-full h-[647px] sm:h-[810px] md:h-[890px] lg:h-[760px] xl:h-[700px] 2xl:h-[720px] text-white flex justify-start items-center pt-20 sm:pt-24 relative bg-cover bg-center"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-[rgba(44,54,88,0.65)] z-0"></div>

      {/* Content */}
      <div className="flex flex-col gap-[24px] sm:gap-[36px] md:gap-[48px] p-6 sm:p-10 md:p-16 lg:p-20 xl:p-28 z-10 w-full sm:w-[90%] md:w-[80%] lg:w-[65%] xl:w-[60%] 2xl:w-[55%]">
      <div className="flex flex-col items-start gap-[20px] sm:gap-[28px] md:gap-[32px]">
      <div>
            <p className="font-nunito text-[20px] sm:text-[22px] md:text-[42px] lg:text-[46px] 2xl:text-[52px] leading-[1.3] text-left">
              Digitally Yours.
            </p>
            <p className="font-nunito text-[20px] sm:text-[22px] md:text-[42px] lg:text-[46px] 2xl:text-[52px] leading-[1.3] text-left">
              We are a Digital Agency.
            </p>
          </div>
          <div>
            <p className="font-nunito text-[12px] sm:text-[12px] md:text-[18px] leading-[1.6] text-justify sm:text-justify">
              eSparse Matrix Solutions Private Limited is a Best Software Development Company that includes Enterprise Software development, Website designing and development, Mobile application development, Digital marketing.
            </p>
          </div>
        </div>
        <div>
          <button className="bg-[#006BD3] px-6 sm:px-[34px] py-3 sm:py-4 text-sm sm:text-base rounded gap-[8px]">
            Get Started
          </button>
        </div>
      </div>

      {/* Hero Image */}
      <div className="absolute bottom-0 right-0 w-[60%] sm:w-1/2 md:w-[45%] lg:w-[40%] xl:w-[36%] h-auto">
        <img
          alt="heroImage"
          src={heroImage}
          className="w-full max-w-[641.48px] h-auto object-contain"
        />
      </div>
    </div>
  );
};

export default Hero;
